import { COLUMN_TYPE } from "utils/constants";
import { UserColumnTypes } from "pages/configs/configs";

export const MANAGE_VERSIONS_COLUMNS: UserColumnTypes[] = [
  { id: "swVersion", label: "Version", isSort: true, type: COLUMN_TYPE.STRING },
  { id: "portalVersion", label: "Portal Label", isSort: true, type: COLUMN_TYPE.STRING },
  { id: "approvedSwVersion", label: "Approved Version", isSort: true, type: COLUMN_TYPE.STRING },
  { id: "allowDownload", label: "Downloadable" },
  { id: "allowVpn", label: "VPN" },
  { id: "action-col", label: "" },
];

export const MANAGE_MODEM_FIRMWARE_COLUMNS: UserColumnTypes[] = [
  { id: "fileName", label: "File", type: COLUMN_TYPE.STRING },
  { id: "downloadPath", label: "Download Path", type: COLUMN_TYPE.STRING },
  { id: "model", label: "Modem Model", type: COLUMN_TYPE.STRING },
  { id: "targetBand", label: "Target Band", type: COLUMN_TYPE.STRING },
  { id: "current", label: "Current" },
];
